import React from 'react';

export default function Elipsis(props: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}) {
  return (
    <svg
      className={props.className}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M12 18L16 13H13V2H11V13H8L12 18Z" fill="#6C757D" />
      <path
        d="M19 9H15V11H19V20H5V11H9V9H5C3.897 9 3 9.897 3 11V20C3 21.103 3.897 22 5 22H19C20.103 22 21 21.103 21 20V11C21 9.897 20.103 9 19 9Z"
        fill="#6C757D"
      />
    </svg>
  );
}
